var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixSocialGroupsV2JoinGroupRequest from '@wix/ambassador-social-groups-v2-join-group-request/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Pending request. */
    RequestStatus["PENDING"] = "PENDING";
    /** Approved request. */
    RequestStatus["APPROVED"] = "APPROVED";
    /** Rejected request. */
    RequestStatus["REJECTED"] = "REJECTED";
    /** Cancelled request. */
    RequestStatus["CANCELLED"] = "CANCELLED";
    /** Canceled request. */
    RequestStatus["CANCELED"] = "CANCELED";
})(RequestStatus || (RequestStatus = {}));
export var ViolationType;
(function (ViolationType) {
    ViolationType["NONE"] = "NONE";
    ViolationType["NOT_LOGGED_IN"] = "NOT_LOGGED_IN";
    ViolationType["ALREADY_JOINED"] = "ALREADY_JOINED";
    ViolationType["SECRET_GROUP"] = "SECRET_GROUP";
    ViolationType["EVENTS"] = "EVENTS";
    ViolationType["PRICING_PlANS"] = "PRICING_PlANS";
    ViolationType["MEMBERSHIP_QUESTIONS"] = "MEMBERSHIP_QUESTIONS";
    ViolationType["ADMIN_APPROVAL"] = "ADMIN_APPROVAL";
})(ViolationType || (ViolationType = {}));
export var ItemsToUpdate;
(function (ItemsToUpdate) {
    /** Take into account only items which are listed in request. */
    ItemsToUpdate["BY_ID"] = "BY_ID";
    /** Update all items. */
    ItemsToUpdate["ALL_ITEMS"] = "ALL_ITEMS";
})(ItemsToUpdate || (ItemsToUpdate = {}));
export var OwnershipFilter;
(function (OwnershipFilter) {
    /** All items. */
    OwnershipFilter["ALL"] = "ALL";
    /** Items for current site member. */
    OwnershipFilter["CURRENT_MEMBER"] = "CURRENT_MEMBER";
})(OwnershipFilter || (OwnershipFilter = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _approveAllJoinGroupRequestsRequest = {};
const _approveAllJoinGroupRequestsResponse = {};
const _approveJoinGroupRequestsRequest = {};
const _approveJoinGroupRequestsResponse = {};
const _cancelJoinGroupRequestRequest = {};
const _cancelJoinGroupRequestResponse = {};
const _getJoinRequirementsRequest = {};
const _getJoinRequirementsResponse = {};
const _listAllJoinGroupRequestsRequest = {};
const _listAllJoinGroupRequestsResponse = {};
const _listJoinGroupRequestsRequest = {};
const _listJoinGroupRequestsResponse = {};
const _queryJoinGroupRequestsRequest = {};
const _queryJoinGroupRequestsResponse = {};
const _rejectAllJoinGroupRequestsRequest = {};
const _rejectAllJoinGroupRequestsResponse = {};
const _rejectJoinGroupRequestsRequest = {};
const _rejectJoinGroupRequestsResponse = {};
const _submitJoinGroupRequestRequest = {};
const _submitJoinGroupRequestResponse = {};
/**
 * Get join group requirements. Will return empty response for public groups and details to fulfil if it's private.
 * @internal
 * @documentationMaturity preview
 * @requiredField groupId
 * @param groupId - ID of the group requested to join.
 * @adminMethod
 */
export function getJoinRequirements(groupId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            groupId: '$[0]',
            membershipQuestionAnswers: '$[1].membershipQuestionAnswers',
            autoInviteId: '$[1].autoInviteId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getJoinRequirementsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getJoinRequirementsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([groupId, options]);
        const reqOpts = ambassadorWixSocialGroupsV2JoinGroupRequest.getJoinRequirements(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'groupId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Submits a join group request.
 * Relevant only for private groups.
 * @internal
 * @documentationMaturity preview
 * @requiredField groupId
 * @param groupId - ID of the group requested to join.
 * @adminMethod
 */
export function submitJoinGroupRequest(groupId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            groupId: '$[0]',
            membershipQuestionAnswers: '$[1].membershipQuestionAnswers',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _submitJoinGroupRequestRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _submitJoinGroupRequestResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['joinGroupRequest']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([groupId, options]);
        const reqOpts = ambassadorWixSocialGroupsV2JoinGroupRequest.submitJoinGroupRequest(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'groupId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Cancels a join group request.
 * A site member can cancel only their own pending Join group requests.
 * @internal
 * @documentationMaturity preview
 * @requiredField groupId
 * @param groupId - ID of the group requested to join.
 * @adminMethod
 */
export function cancelJoinGroupRequest(groupId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { groupId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _cancelJoinGroupRequestRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _cancelJoinGroupRequestResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['joinGroupRequest']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([groupId]);
        const reqOpts = ambassadorWixSocialGroupsV2JoinGroupRequest.cancelJoinGroupRequest(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'groupId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Approves requests to join a group.
 *
 * > **Note:** This function is only relevant for private groups.
 *
 * The `approvejoinGroupRequests()` function returns a Promise that resolves when a site member's request to join a group is approved.
 * Only site admins and group admins can approve site member requests to join a group, unless the group setting, `membersCanApprove` is set to `true`.
 *
 * <!--
 * > **Note:** If the `suppressAuth` option is set to `true`, all permissions are overwritten, and all site members (including non-group members) can approve site member requests to join a group.
 * -->
 * @param memberIds - IDs of the site members to approve.
 * @public
 * @requiredField groupId
 * @requiredField memberIds
 * @param groupId - ID of the group requested to join.
 * @adminMethod
 */
export function approveJoinGroupRequests(groupId, memberIds, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            groupId: '$[0]',
            memberIds: '$[1]',
            itemsToApprove: '$[2].itemsToApprove',
            siteMemberIds: '$[2].siteMemberIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _approveJoinGroupRequestsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _approveJoinGroupRequestsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#joinGroupRequests']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([groupId, memberIds, options]);
        const reqOpts = ambassadorWixSocialGroupsV2JoinGroupRequest.approveJoinGroupRequests(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'groupId',
                'memberIds',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Rejects requests to join a group.
 *
 * > **Note:**  This function is only relevant for private groups.
 *
 * The `rejectjoinGroupRequests()` function returns a Promise that resolves when the site member's request to join a group is rejected.
 * Only site admins or group admins can reject site member requests to join the group, unless the group setting, `membersCanApprove` is set to `true`.
 *
 * <!--
 * > **Note:** If the `suppressAuth` option is set to `true`, all permissions are overwritten, and all site members (including non-group members) can reject site member requests to join a group.
 * -->
 *
 * @param rejections - Rejection data.
 * @public
 * @requiredField groupId
 * @requiredField rejections
 * @param groupId - ID of the group requested to join.
 * @adminMethod
 */
export function rejectJoinGroupRequests(groupId, rejections, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            groupId: '$[0]',
            rejections: '$[1]',
            itemsToReject: '$[2].itemsToReject',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _rejectJoinGroupRequestsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _rejectJoinGroupRequestsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#joinGroupRequests']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([groupId, rejections, options]);
        const reqOpts = ambassadorWixSocialGroupsV2JoinGroupRequest.rejectJoinGroupRequests(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'groupId',
                'rejections',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Lists requests to join a group.
 *
 * > **Note:** This function is only relevant for private groups.
 *
 * The `listjoinGroupRequests()` function returns a Promise that resolves to a list of up to 100 requests to join a group. Sorts by default to `_createdDate` in descending order.
 * Only site admins and group admins can see requests to join their group. Site members can access their own join requests in their site.
 *
 * > **Notes:**
 * <!-- > + If the `suppressAuth` option is set to `true`, all permissions are overwritten, and all site members (including non-group members) can see requests to join a group. -->
 * @public
 * @requiredField groupId
 * @param groupId - ID of the group requested to join.
 * @adminMethod
 */
export function listJoinGroupRequests(groupId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            groupId: '$[0]',
            ownershipFilter: '$[1].ownershipFilter',
            limit: '$[1].limit',
            offset: '$[1].offset',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listJoinGroupRequestsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listJoinGroupRequestsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#joinGroupRequests']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([groupId, options]);
        const reqOpts = ambassadorWixSocialGroupsV2JoinGroupRequest.listJoinGroupRequests(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'groupId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a query to retrieve a list of join requests.
 *
 * > **Notes:**
 * > + This function is only relevant for private groups.
 * > + For `SECRET` groups, only site admins and group admins can query requests to join their group. <!-- However, if the `suppressAuth` option is set to `true`, all permissions are overwritten, and all site members (including non-group members) can query requests to join a group. -->
 *
 * The `queryjoinGroupRequests()` function builds a query to retrieve a list of all requests to join a group, and returns a `JoinGroupRequestsQueryBuilder` object.
 *
 * The returned object contains the query definition which is typically used to run the query using the [`find()`](/join-group-requests-query-builder/find) function.
 *
 * You can refine the query by chaining `joinGroupRequestsQueryBuilder` functions onto the query. `joinGroupRequestsQueryBuilder` functions enable you to sort, filter, and control the results that `queryjoinGroupRequests()` returns.
 *
 * The results of the `queryjoinGroupRequests()` function are sorted by `_createdDate` in descending order.
 *
 * `queryjoinGroupRequests()` runs with this `joinGroupRequestsQueryBuilder` default, which you can override:
 * + [`limit(100)`](/join-group-requests-query-builder/limit)
 *
 * The following `joinGroupRequestsQueryBuilder` functions are supported for `queryjoinGroupRequests()`. For a full description of the joinGroupRequests object, see the object returned for the [`items`](/join-group-requests-query-result/items) property in `JoinGroupRequestsQueryResult`.
 *
 * @public
 * @requiredField groupId
 * @param groupId - Group ID.
 * @adminMethod
 */
export function queryJoinGroupRequests(groupId, options) {
    const requestTransformation = { groupId: '$[1]', '*': '$[2]', query: '$[0]' };
    const responseTransformation = {
        items: '$.joinGroupRequests',
        pagingMetadata: '$.metadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[2];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryJoinGroupRequestsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryJoinGroupRequestsResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#joinGroupRequests']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixSocialGroupsV2JoinGroupRequest.queryJoinGroupRequests(Object.assign(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})), { groupId }));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'OFFSET',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/** @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function rejectAllJoinGroupRequests() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _rejectAllJoinGroupRequestsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _rejectAllJoinGroupRequestsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#joinGroupRequests']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixSocialGroupsV2JoinGroupRequest.rejectAllJoinGroupRequests(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function approveAllJoinGroupRequests() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _approveAllJoinGroupRequestsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _approveAllJoinGroupRequestsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#joinGroupRequests']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixSocialGroupsV2JoinGroupRequest.approveAllJoinGroupRequests(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function listAllJoinGroupRequests(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { query: '$[0].query' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listAllJoinGroupRequestsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listAllJoinGroupRequestsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#joinGroupRequests']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixSocialGroupsV2JoinGroupRequest.listAllJoinGroupRequests(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=social-groups-v2-join-group-request.universal.js.map